import { InjectionToken } from '@angular/core';
import { DatepickerTranslationConfig } from '../interfaces/datepicker-translations-config.interface';

export const DATEPICKER_TRANSLATION_CONFIG = new InjectionToken<DatepickerTranslationConfig>(
	'DATEPICKER_TRANSLATION_CONFIG'
);
